import { SVGProps } from 'react';
import { CONFIG_ICON } from './config-icon';
import { useTheme } from 'hooks/theme';

const DenyIcon = (props: SVGProps<SVGSVGElement>) => {
  const { theme } = useTheme();
  const config_icon = CONFIG_ICON[theme];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={24}
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <circle
        cx={12.5}
        cy={12}
        r={9}
        stroke={config_icon.secondary}
        strokeWidth={2}
      />
      <path
        fill={config_icon.secondary}
        fillRule="evenodd"
        d="M12.5 10.586 17.586 5.5 19 6.914 13.914 12 12.5 13.414l-5 5L6.086 17l5-5 1.414-1.414Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default DenyIcon;
